import type { SimScenario } from './scenarios';

export const SIM_SCENARIO_LABELS_UK: Record<SimScenario, string> = {
  normal: 'Норма',
  wan_failover: 'Failover WAN',
  critical_down: 'Критичний DOWN',
  sleeping_tablet: 'Sleeping tablet',
  passive_switch: 'Passive switch',
  stale: 'Stale',
  no_heartbeat: 'Немає heartbeat',
  reboot: 'Reboot',
  counter_reset: 'Counter reset',
  duplicate_sequence: 'Duplicate seq',
};

export const SIM_SCENARIO_ORDER: SimScenario[] = [
  'normal',
  'wan_failover',
  'critical_down',
  'sleeping_tablet',
  'stale',
  'no_heartbeat',
  'reboot',
  'counter_reset',
  'duplicate_sequence',
];
